/// <reference path="typings/elearning.d.ts" />

export default class AjaxLoader {

    private callbackSuccess: any;
    private callbackFailed: any;

    constructor(callbackSuccess, callBackFailed?) {
        this.callbackSuccess = callbackSuccess;
        this.callbackFailed = callBackFailed;
    }

    requestUrl(url) {
        let xhttp = new XMLHttpRequest();

        xhttp.onreadystatechange = () => {
            if (xhttp.readyState === 4) {
                if (xhttp.status === 200) {
                    this.onSuccess(xhttp);
                }
                else if (xhttp.status === 404 || xhttp.status === 500) {
                    if (typeof (this.callbackFailed) === 'function') {
                        this.onFailed(xhttp);
                    } else {
                        console.warn(`Request failed:/\n${xhttp.status}`);
                    }
                }
            }
        };

        xhttp.open('Get', url);
        xhttp.send();
    }

    onSuccess(xhttp) {
        if (typeof (this.callbackSuccess) === 'function') {
            this.callbackSuccess(xhttp.responseText);
        }
    }

    onFailed(xhttp) {
        if (typeof (this.callbackFailed) === 'function') {
            this.callbackFailed(xhttp);
        }
    }
}
